module.exports = __webpack_public_path__ + "img/K.S.c9a4acab.png";